import { AdhocHoldOfCntrEntity } from "domain/entity/AdhocHoldOfContainer/AdhocHoldOfCntrEntity";
import { AdhocHoldOfCntrSearchCriteria } from "domain/entity/AdhocHoldOfContainer/AdhocHoldOfCntrSearchCriteria";
import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { axiosPostData } from "../axios/AxiosBasicImpl";
import chargeAxiosInstance from "../axios/chargeAxiosInstance";
import { AdhocHoldOfCntrRepository } from "./AdhocHoldOfCntrRepo";

export const AdhocHoldOfCntrRepoImpl = (): AdhocHoldOfCntrRepository => {

    const getAdhocHoldDatas = async (searchCriteria: AdhocHoldOfCntrSearchCriteria): Promise<AdhocHoldOfCntrEntity[]> => {
        const url = "/v1/searchAdhocHold";
        return axiosPostData(chargeAxiosInstance, `${url}`, searchCriteria).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }

    const onHold = async (selectCharges: AdhocHoldOfCntrEntity[]): Promise<ResponseEntity> => {
        const newUrl = "/v1/adhocHold";
        return axiosPostData(chargeAxiosInstance, `${newUrl}`, selectCharges).then(res => {
            // const data = res.data;
            // return data;
            return res;
        }).catch(err => {
            return err;
        });
    }

    return {
        getAdhocHoldDatas: getAdhocHoldDatas,
        onHold: onHold
    }
}